var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('el-row', {
    staticStyle: {
      "margin-top": "10%",
      "padding": "0 5%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索",
      "prefix-icon": "el-icon-search",
      "size": "mini"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      "props": _vm.defaultProps,
      "lazy": "",
      "load": _vm.loadNode,
      "node-key": "id",
      "current-node-key": _vm.currentId,
      "filter-node-method": _vm.filterNode,
      "highlight-current": true,
      "default-checked-keys": [_vm.currentId]
    },
    on: {
      "node-click": _vm.parentFind
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var data = ref.data;

        return _c('div', {}, [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_vm._v(_vm._s(data.organize_name) + "(" + _vm._s(data.organize_number) + "人)")])])])
      }
    }])
  })], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177f8dfc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/structure/structure.vue
// module id = null
// module chunks = 